exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".choice-title{margin-bottom:10px}.choice-text-error{display:inline-block;font-size:.75rem;font-weight:400;color:#d90000;padding-top:8px}.choice-field.choice-error .form-radio-label{border-bottom:1px solid #d90000}.choice-field label{padding-left:30px;padding-right:10px;min-width:90px;margin-left:0;margin-right:0;margin-bottom:10px}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/sass-loader!./src/components/ContactUs/Choice/Choice.scss
 ** module id = 1190
 ** module chunks = 0
 **/